import OwnerAlphaListing from './OwnerAlphaListing';

export default OwnerAlphaListing;
